import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDividerModule} from '@angular/material/divider';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ColaboradoresEncuestaComponent } from './colaboradores-encuesta.component';
// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';

// SERVICIO AUTORIZACION E INTERCEPTION DE TOKEN
import { AuthGuard } from 'app/auth/auth.guard';
import { MatNativeDateModule } from '@angular/material/core';
import {MatInputModule} from '@angular/material/input';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatMenuModule} from '@angular/material/menu';
import {MatCardModule} from '@angular/material/card';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatListModule} from '@angular/material/list';
import {MatTabsModule} from '@angular/material/tabs';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatDialogModule} from '@angular/material/dialog';
import {MatRadioModule} from '@angular/material/radio';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatSelectModule} from '@angular/material/select';


const rutas: Routes = [
    // trust index
    {
        path     : 'NOM35/colaboradores-encuesta',
        component: ColaboradoresEncuestaComponent,
        canActivate: [AuthGuard]
    }
];

@NgModule({
  declarations: [ColaboradoresEncuestaComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    FlexLayoutModule,
    MatProgressBarModule,
    TranslateModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatDividerModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatNativeDateModule,
    MatInputModule,
    MatSortModule,
    MatTableModule,
    MatButtonToggleModule,
    MatToolbarModule,
    MatMenuModule,
    MatCardModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatListModule,
    MatTabsModule,
    BrowserModule,
    FormsModule, 
    ReactiveFormsModule,
    MatGridListModule,
    MatRadioModule,
    MatDialogModule,
    MatDatepickerModule,
    BrowserAnimationsModule,
    MatSelectModule,
    
  ]
})
export class ColaboradoresEncuestaModule { }
